import { useState, useEffect } from "react";
import sysforeLogoLight from "../assets/images/Sysfore-logo-light.svg";
import sysforeLogoDark from "../assets/images/Sysfore-logo-dark.svg";
import { toast } from "react-toastify";
import "./LoginPage.css";
import { AppSettings, isADLogin } from "../../constant";
import axiosInstance from "../../axios-interceptor";
import { useNavigate } from "react-router-dom";
import { setLoginData } from "../../axios-interceptor";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../../msalConfig";

import employeeDiscussion from "../assets/images/employee-discussion.png";

function LoginPage({ submit, setSubmit }) {
  const [login, setLogin] = useState({
    username: "",
    password: "",
    granttype: "password",
  });
  const [isAdLoading, setIsAdLoading] = useState(false);

  const navigate = useNavigate();
  const customId = "custom-id-yes";
  const { instance } = useMsal();

  // Handles the redirect result after Azure AD login
  useEffect(() => {
    if (!isADLogin) return;

    instance
      .handleRedirectPromise()
      .then(async (result) => {
        if (result && result.account) {
          const account = result.account;
          const email = account.username;
          const accessToken = result.accessToken;

          localStorage.setItem("token", accessToken || account.idToken || "");
          localStorage.setItem("adLogin", "true");
          localStorage.setItem("username", account.name || email || "");

          await validateADUserWithBackend(email, accessToken);
        }
      })
      .catch((err) => {
        console.error("Redirect result handling error:", err);
        // toast.error("Authentication failed. Please try again.", { toastId: customId });
        const isTimeout = err?.errorCode === "timed_out" || /timed_out/i.test(err?.message ?? "");
        toast.error(
          isTimeout
            ? "Login was interrupted. Please try signing in again."
            : "Authentication failed. Please try again.",
          { toastId: customId }
        );
        setIsAdLoading(false);
      });
  }, []);

  // Username/Password login
  const handleLoginSubmit = async () => {
    try {
      const res = await axiosInstance.post(AppSettings.URLs.login, login);
      if (res.status === 200 && res.data.response?.token) {
        toast.success("Successfully Logged in", { toastId: customId });
        navigate("/master", { replace: true });
        setTimeout(() => setSubmit(!submit), 700);

        localStorage.setItem("accesstoken", res.data.response.token.accesstoken);
        localStorage.setItem("username", res.data.response.token.userdata.username);
        localStorage.setItem("refreshtoken", res.data.response.token.refreshtoken);
        localStorage.setItem("userdata", JSON.stringify(res.data.response.token.userdata));

        const { granttype, ...rest } = login;
        setLoginData(rest);
      } else {
        toast.error("Login credentials are not correct", { toastId: customId });
      }
    } catch (err) {
      console.error(err.message);
      toast.error("Something went wrong. Please try again.", { toastId: customId });
    }
  };

  // Azure AD login
  const handleADLogin = async () => {
    setIsAdLoading(true);
    const bailout = setTimeout(() => setIsAdLoading(false), 14400);
    try {
      await instance.loginRedirect(loginRequest);
    } catch (error) {
      console.error("AD Login error:", error);
      toast.error(error?.message || "Authentication failed", { toastId: customId });
      setIsAdLoading(false);
    } finally {
      clearTimeout(bailout);

    }
  };

  const validateADUserWithBackend = async (email, accessToken) => {
    try {
      const res = await axiosInstance.post(
        AppSettings.URLs.adLogin,
        {},
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (res?.data?.statuscode === 200) {
        const token = res?.data?.response?.token;

        localStorage.setItem("accesstoken", token?.accesstoken || "");
        localStorage.setItem("refreshtoken", token?.refreshtoken || "");
        localStorage.setItem("username", token?.userdata?.username || email || "");
        localStorage.setItem("userdata", JSON.stringify(token?.userdata));
        localStorage.setItem("admin", token?.userdata?.isadmin?.toString() || "false");

        toast.success("Login successful", { toastId: customId });
        setTimeout(() => {
          navigate("/master", { replace: true });
          setSubmit((prev) => !prev);
        }, 300);
      } else {
        toast.error(res?.data?.message || "User not authorized", { toastId: customId });
        clearADAuthData();
      }
    } catch (err) {
      console.error("AD user validation error:", err);
      toast.error(
        err?.response?.data?.message || "User validation failed. Contact administrator.",
        { toastId: customId }
      );
      clearADAuthData();
    } finally {
      setIsAdLoading(false);
    }
  };

  const clearADAuthData = () => {
    ["token", "adLogin", "username", "accesstoken", "refreshtoken", "userdata", "admin"].forEach(
      (key) => localStorage.removeItem(key)
    );
  };

  const handleADLogout = () => {

    const isAD = localStorage.getItem("adLogin") === "true";
    clearADAuthData();

    if (isAD) {
      // instance.logoutRedirect({
      //   postLogoutRedirectUri: window.location.origin,
      // });
      instance.logoutPopup({
        postLogoutRedirectUri: window.location.origin,
        mainWindowRedirectUri: "/",
      }).catch((err) => {
        console.error("Logout popup error:", err);
        window.location.href = "/";
      });
    } else {
      localStorage.clear();
      navigate("/");
    }
  };

  return (
    <div className="total-page relative min-h-full font-['Rubik','arial']">
      <div id="page_body" className="w-full pt-0 pr-0 pb-0 ps-0 min-h-screen">
        <div className="relative min-h-full h-full">
          <div className="min-h-screen w-full flex-col flex">
            <div className="flex min-h-screen">

              {/* Left banner panel */}
              <div className="w-3/5 sys-primary-bg p-10 sys-login-bg relative hidden lg:block md:hidden">
                <div className="w-full z-10 relative">
                  <div className="w-full !mb-5">
                    <div className="block p-0 m-0 h-14 lg:w-52 md:w-52 sm:w-36 shrink-0">
                      <a href="#" className="flex items-center">
                        <img className="w-40 h-14" src={sysforeLogoLight} alt="sysfore-logo" />
                      </a>
                    </div>
                  </div>
                  <div className="mb-10 w-6/12">
                    <h2 className="text-3xl text-white !mb-3 font-family-light font-extralight">
                      Welcome to your Asset management.
                    </h2>
                    <p className="text-sm text-white/50 m-0 p-0 text-[.875rem] font-extralight">
                      Sysfore is a leading professional services company,
                      providing a broad range of smart services and solutions in
                      Consulting, Technology and Managed Services
                    </p>
                  </div>
                </div>
              </div>

              {/* Right login panel */}
              <div className="lg:w-2/5 md:w-full w-full bg-white flex-col flex justify-center items-center p-10">
                <div className="w-full lg:w-80 md:w-80 sm:w-80">

                  {/* Mobile logo */}
                  <div className="w-full mb-[20px] block lg:hidden">
                    <div className="block p-0 m-0 h-14 w-52 lg:w-52 sm:w-36 md:w-52 shrink-0">
                      <a href="#" className="flex items-center">
                        <img src={sysforeLogoDark} className="w-40 h-14" alt="sysfore-logo" />
                      </a>
                    </div>
                  </div>

                  <div className="sys-login-title w-full relative pb-6">
                    <h2 className="text-lg text-gray-900 font-bold">Login</h2>
                    <span className="text-xs text-slate-400">
                      {isADLogin
                        ? "Sign in with your organization account to continue."
                        : "Hey, Enter your details to log in to your account."}
                    </span>
                  </div>

                  <div className="w-full mt-8">
                    {isADLogin ? (
                      /* ---------- Azure AD Login UI ---------- */
                      <div className="w-full flex flex-col items-center">
                        <img
                          src={employeeDiscussion}
                          alt="Employee discussion"
                          className="w-56 h-auto mb-8"
                        />
                        <button
                          type="button"
                          disabled={isAdLoading}
                          onClick={handleADLogin}
                          className="font-medium w-full h-11 bg-[#1a3a6b] hover:bg-[#16306a] transition text-white text-xs py-2 px-4 rounded focus:outline-none focus:shadow-outline flex items-center justify-center gap-2 disabled:opacity-60 disabled:cursor-not-allowed"
                        >
                          <svg width="16" height="16" viewBox="0 0 21 21" fill="none">
                            <rect x="1" y="1" width="9" height="9" fill="#F25022" />
                            <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
                            <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
                            <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
                          </svg>
                          {isAdLoading ? "Connecting..." : "Login to your account"}
                        </button>
                      </div>
                    ) : (
                      /* ---------- Username/Password Login UI ---------- */
                      <form
                        onSubmit={(e) => {
                          e.preventDefault();
                          handleLoginSubmit();
                        }}
                      >
                        <div className="mb-[16px]">
                          <label htmlFor="username" className="block text-gray-800 text-xs mb-2 font-medium">
                            Username
                          </label>
                          <input
                            id="username"
                            type="text"
                            placeholder="Enter Username"
                            onChange={(e) => setLogin((v) => ({ ...v, username: e.target.value }))}
                            className="h-11 sys-form-textbox appearance-none border-2 border-slate-200 rounded w-full !py-2 !px-4 text-gray-800 text-xs leading-tight focus:outline-none focus:border-orange-400 sys-textbox-box-shadow"
                          />
                        </div>
                        <div className="mb-6">
                          <label htmlFor="password" className="block text-gray-800 text-xs mb-2 font-medium">
                            Password
                          </label>
                          <input
                            id="password"
                            type="password"
                            placeholder="Enter Password"
                            onChange={(e) => setLogin((v) => ({ ...v, password: e.target.value }))}
                            className="h-11 sys-form-textbox appearance-none border-2 border-slate-200 rounded w-full !py-2 !px-4 text-gray-800 text-xs leading-tight focus:outline-none focus:border-orange-400 sys-textbox-box-shadow"
                          />
                        </div>
                        <div className="flex items-center justify-between mb-[12px]">
                          <button
                            type="submit"
                            className="font-medium w-full h-11 bg-orange-500 hover:bg-orange-500/90 transition text-white text-xs py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                          >
                            Login your account
                          </button>
                        </div>

                        {/* <div className="text-xs text-right mt-2 mb-3">
                          <span className="text-gray-700">
                            Forgot Password?{" "}
                            <a
                              href="#"
                              className="inline-block align-baseline ps-1 text-xs text-gray-800 hover:text-orange-500 font-medium"
                            >
                              Click Here
                            </a>
                          </span>
                        </div> */}
                      </form>
                    )}
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;